export enum InvestigationReadOnlyReason {
	NotAssignedInvestigator = "NOT_ASSIGNED_INVESTIGATOR",
	StageNotEditable = "STAGE_NOT_EDITABLE",
}
